import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Rx';
// import { WebsocketService } from './websocket-service';

import { Message } from '../models';

// this.date = new Date().toISOString();
// //this.serveraddr = 'ws://mechow.duckdns.org:23077/{"e":"mitchell@intelligentconcepts.com", "p":"qwerty", "t":"';
// this.serveraddr = 'ws://192.168.1.6:23077/{"e":"mitchell@intelligentconcepts.com", "p":"qwerty", "t":"';
// this.key = '","k":"f2mVZeO8xrC1nQjhEkT4gdOcQsXy4OK7wP2MFreSgYg="}';
// //const STATUS_URL = 'ws://echo.websocket.org/';
// const STATUS_URL = this.serveraddr + this.date + this.key;

@Injectable()
export class StatusService {

  public messages: Subject<Message> = new Subject<Message>();
  json: any;


  constructor() {
    

    //console.log(user);
    // .map(user => {
    //   var departmentName = this.json.departments.find(d => d.i == user.d);
    //
    //   if (departmentName) {
    //     user.d = departmentName.name;
    //   }
    //
    //   //Asume that custom_fields array are sorted by Id
    //   user.c = user.c.map((custom, idx) => {
    //     return {...custom, ...this.json.c[idx]};
    //   });
    //   return user;
    //
    // });


    // let users = this.json.users;
    // users.map(user => {
    //   var departmentName = this.json.departments.find(d => d.i == user.department);
    //
    //   if (departmentName) {
    //     user.department_name = departmentName.name;
    //   }
    //
    //   //Asume that custom_fields array are sorted by Id
    //   user.custom_fields = user.custom_fields.map((custom, idx) => {
    //     return {...custom, ...this.json.custom_fields[idx]};
    //   });
    //   return user;
    //
    // });


    //console.log("Merged:" + users);
  }

  

  // public getAll(STATUS_URL) {
  //   return <Subject<Message>>this.wsService
  //     .connect(STATUS_URL)
  //     .map((response: MessageEvent): Message => {
  //       let msg = JSON.parse(response.data);
  //       console.log(msg)
  //       return msg
  //     })
  // }

}



// WEBPACK FOOTER //
// ./src/providers/status-service.ts